import type { NextPage } from "next";
import { useTranslation } from "next-i18next";
import { ReactElement } from "react";
import Projects from ".";
import { NWONPage } from "../../config/NWONPage";
import NWONHeroSection from "../../src/components/03-organisms/NWONHeroSection/NWONHeroSection";
import NWONProjectIntroductionSection from "../../src/components/03-organisms/NWONProjectIntroductionSection/NWONProjectIntroductionSection";
import NWONProjectStepsSection from "../../src/components/03-organisms/NWONProjectStepsSection/NWONProjectStepsSection";
import { NWONInitial } from "../../src/components/NWONInitial/NWONInitial";
import { useProjectMapping } from "../../src/data/projects/useAllProjects";
import { getStaticProjectPaths } from "../../src/helpers/pageCreation/projectPageCreation/getStaticProjectPaths";
import { getStaticProjectProps } from "../../src/helpers/pageCreation/projectPageCreation/getStaticProjectProps";
import {
  GetStaticProjectPaths,
  GetStaticProjectProps,
  ProjectPageProps,
} from "../../src/helpers/pageCreation/projectPageCreation/projectPageCreationInterfaces";

const Project: NextPage<ProjectPageProps> = (props): ReactElement | null => {
  const projectMapping = useProjectMapping();
  const { t } = useTranslation<"pages">("pages");

  if (!props.project) {
    return <Projects />;
  }

  const projectData = projectMapping[props.project];

  return (
    <NWONInitial
      pageInformationData={{ page: NWONPage.Projects, project: props.project }}
    >
      <NWONHeroSection
        caption={t("projects.heroSection.caption")}
        title={projectData.title}
        subtitle={projectData.subtitle}
        slideInformation={projectData.details.heroImages.map((image) => ({
          image,
        }))}
      />

      <NWONProjectIntroductionSection project={projectData} />

      <NWONProjectStepsSection steps={projectData.details.steps} />
    </NWONInitial>
  );
};

export const getStaticProps: GetStaticProjectProps = async (context) => {
  return getStaticProjectProps(context);
};

export const getStaticPaths: GetStaticProjectPaths = async (context) => {
  return getStaticProjectPaths(context);
};

export default Project;
